import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartsModule } from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { HomeService } from './services/home.service';
import * as moment from 'moment';
import { ActivityLogShort, ActivityLog } from 'shared/classes/activityLog';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})

export class HomeComponent implements OnInit {

  private activityDays = 7;

  public activityCompany: string = 'Alle';

  public activityCompanies =  ['Alle'];

  private tempChartLabels: Array<any> = [];

  public chartActivity = {
    datasets: [
      { data: [],
        label: 'Aktive Nutzer'},
      { data: [],
        label: 'Mindset'},
      { data: [],
        label: 'Wirksamkeit'},
      { data: [],
        label: 'Leistungsfähigkeit'},
      { data: [],
        label: 'Mood'},
      { data: [],
        label: 'Dialog-Antworten'},
      ],
    labels: [],
    options: {
      responsive: true,
      scales : {
        yAxes: [{
          ticks: {
            max : 60,
            min : 0,
          }
        }],
        xAxes: [{


          }],
      },
        plugins: {
        datalabels: {
          display: true,
          align: 'top',
          anchor: 'end',
          //color: "#2756B3",
          color: "#222",

          font: {
            family: 'FontAwesome',
            size: 14
          },

        },
        deferred: false

      },
    },
    colors: [
      {backgroundColor: '#48f', borderColor: '#44f'},
      {backgroundColor: '#FFC733', borderColor: '#FF8333'},
      {backgroundColor: '#F65011', borderColor: '#F61811'},
      {backgroundColor: '#11A425', borderColor: '#16501E'},
      {backgroundColor: '#8080FF', borderColor: '#8080FF'},
      {backgroundColor: '#FF80FF', borderColor: '#FF80FF'},
    ],
  };

  public chartThesis = {
    datasets: [
        { data: [],
          label: 'Mindset',
          fill: false,
          pointBackgroundColor: '#FFC733'},
        { data: [],
          label: 'Wirksamkeit (Efficacy)',
          fill: false,
          pointBackgroundColor: '#F65011'},
        { data: [],
          label: "Leistungsfähigkeit",
          fill: false,
          pointBackgroundColor: '#11A425'},
        { data: [],
          label: "Mood",
          fill: false,
          pointBackgroundColor: '#8080FF'},
        ],
    labels: [],
    options: {
      responsive: true,
      scales : {
        yAxes: [{
          ticks: {
            max : 2.5,
            min : -2.5,
          }
        }],
        xAxes: [{ }],
      },
      plugins: {
        datalabels: {
          display: true,
          align: 'top',
          anchor: 'end',
          //color: "#2756B3",
          color: "#222",

          font: {
            family: 'FontAwesome',
            size: 14
          },
        },
        deferred: false

      },
    },
    colors: [
      {borderColor: '#FFC733'},
      {borderColor: '#F65011'},
      {borderColor: '#11A425'},
      {borderColor: '#8080FF'},
    ],
  };

  private activityData = [];
  private thesisData: Dictionary<Array<ActivityLog>> = {
    mindset: [],
    efficacy: [],
    performance: [],
    mood: [],
  };
  private dialogAnswerData = [];

  public chartUser = {
    datasets: [
        { data: [],
          label: 'Neue Nutzer',
          fill: false,
          pointBackgroundColor: '#FFC733'},
        { data: [],
          label: 'Erstnutzung App',
          fill: false,
          pointBackgroundColor: '#F65011'},
        ],
    labels: [],
    options: {
      responsive: true,
      scales : {
        yAxes: [{
          ticks: {
            max : 10,
            min : 0,
          }
        }],
        xAxes: [{ }],
      },
      plugins: {
        datalabels: {
          display: true,
          align: 'top',
          anchor: 'end',
          //color: "#2756B3",
          color: "#222",

          font: {
            family: 'FontAwesome',
            size: 14
          },
        },
        deferred: false

      },
    },
    colors: [
      {borderColor: '#FFC733'},
      {borderColor: '#F65011'},
    ],
  };

  private usersData = [[], []];

  public userCompany: string = 'Alle';

  public userCompanies =  ['Alle'];

  public userCompaniesData = {};

  public userSteps = {
    'Jährlich': {format: 'YY', step: '30', days: 12*365 },
    'Quartal':  {format: 'YY/Q', step: '20', days: 12*93 },
    'Monatlich':  {format: 'YY.MM', step: '20', days: 12*30 },
    'Wöchentlich':  {format: 'YY:ww', step: '5', days: 12*7 },
    'Täglich':  {format: 'DD.MM.YY', step: '1', days: 12 },
  };

  public userStepKeys = Object.keys(this.userSteps);

  public userStep = 'Quartal';

  public userMinDay: string;

  public userMaxDay: string;

  public userStartDay: string;

  public userEndDay: string;

  constructor(private homeService: HomeService) { }

  public ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    const startMoment = moment().utc().startOf('day').subtract(this.activityDays-1, 'day').locale('de');
    const startDate = startMoment.toDate().toISOString().split('T')[0];
    this.homeService.getActivityByCompany(startDate, '')
      .subscribe((logs: Array<ActivityLog>) => {
        this.activityData = logs;
        const hash = {};
        logs.forEach(log => {
          hash[log._id.company] = 1;
        });
        this.activityCompanies = ['Alle'].concat(Object.keys(hash).sort());
        this.showCompany();
      });
 
    this.homeService.getThesisActivityByCompany(startDate, '')
    .subscribe((logs: Dictionary<Array<ActivityLog>>) => {
      this.thesisData = logs;
      this.showCompany();
    });

    this.homeService.getDialogAnswerActivityByCompany(startDate, '')
      .subscribe((logs: Array<ActivityLog>) => {
        this.dialogAnswerData = logs;
        this.showCompany();
      });

    this.homeService.getUsersCreated()
      .subscribe((logs) => {
        this.usersData[0] = logs;

        this.userMaxDay = moment().format("YYYY-MM-DD");
        this.userMinDay = logs.reduce((m, log) => m < log._id.day ? m : log._id.day, this.userMaxDay);

        this.userStartDay = this.userMinDay;
        this.userEndDay = this.userMaxDay;

        this.calcUserCompanies();
        this.showUsers();
      });
      this.homeService.getUsersFirstUsed()
      .subscribe((logs) => {
        this.usersData[1] = logs;
        this.showUsers();
      });
  }

  public showCompany(): void {
    const startMoment = moment().utc().startOf('day').subtract(this.activityDays-1, 'day').locale('de');
    const startDate = startMoment.toDate().toISOString().split('T')[0];
    this.homeService.getActivityByCompany(startDate, '')
    const activityHash = this.makeActivityHash(this.activityData, this.activityCompany);
    const dialogAnswerHash = this.makeActivityHash(this.dialogAnswerData, this.activityCompany);

    let max = 10;
    Object.keys(activityHash).forEach(key => {
      if (activityHash[key].count > max) {
        max = activityHash[key].count;
      }
    });
    Object.keys(dialogAnswerHash).forEach(key => {
      if (dialogAnswerHash[key].count > max) {
        max = dialogAnswerHash[key].count;
      }
    });
    this.chartActivity.options.scales.yAxes[0].ticks.max = Math.ceil(max/10)*10;
    let moment1 = startMoment.clone();
    for (let i = 0; i < this.activityDays; i++) {
      this.tempChartLabels[i] = moment1.format('dd DD MMM');
      const key = moment1.toDate().toISOString().split('T')[0];
      this.chartActivity.datasets[0].data[i] = activityHash[key] ? activityHash[key].count : 0;
      this.chartActivity.datasets[5].data[i] = dialogAnswerHash[key] ? dialogAnswerHash[key].count : 0;
      moment1 = moment1.add(1, 'day')
    }

    this.showTheses(this.makeActivityHash(this.thesisData['mindset'], this.activityCompany), startMoment, this.chartActivity.datasets[1].data, this.chartThesis.datasets[0].data);
    this.showTheses(this.makeActivityHash(this.thesisData['efficacy'], this.activityCompany), startMoment, this.chartActivity.datasets[2].data, this.chartThesis.datasets[1].data);
    this.showTheses(this.makeActivityHash(this.thesisData['performance'], this.activityCompany), startMoment, this.chartActivity.datasets[3].data, this.chartThesis.datasets[2].data);
    this.showTheses(this.makeActivityHash(this.thesisData['mood'], this.activityCompany), startMoment, this.chartActivity.datasets[4].data, this.chartThesis.datasets[3].data);

    this.refreshChart();
    this.refreshChartTheses();
  }

  private makeActivityHash(logs: Array<ActivityLog>, company: string): Dictionary<ActivityLogShort> {
    const hash = {};
    logs.forEach(log => {
      if (company == 'Alle') {
        if (!hash[log._id.day]) {
          hash[log._id.day] = {count: 0, summx: 0};
        }
        hash[log._id.day].count += log.count;
        if (log.summx) {
          hash[log._id.day].summx += log.summx;
        }
      }
      else if (log._id.company == company) {
        hash[log._id.day] = log;
      }

    });
    return hash;
  }

  public chartClicked(e: any): void {
    console.log(e);
  }
  public chartHovered(e: any): void {
    console.log(e);
  }

  private showTheses(hash: Dictionary<ActivityLogShort>, startMoment, target, thesesTarget) {
    let moment1 = startMoment.clone();
    for (let i = 0; i < this.activityDays; i++) {
      const key = moment1.toDate().toISOString().split('T')[0];
      target[i] = hash[key] ? hash[key].count : 0;
      thesesTarget[i] = hash[key] && hash[key].count > 0 ? ((hash[key].summx / hash[key].count) - 3).toFixed(2) : null;
      moment1 = moment1.add(1, 'day')
    }
}

private calcUserCompanies() {
    const hash = {};
    this.usersData[0].forEach(log => {
      if (this.userStartDay <= log._id.day && log._id.day <= this.userEndDay) {
        hash[log._id.company] = 1;
      }
    });
    this.userCompanies = ['Alle'].concat(Object.keys(hash).sort());
  }

  public showUsers() {
    if (!this.usersData[0][0])
      return;
    let res = [[], []];
    let labels = [];
    let labelsHash = {};
    const keyFormat = this.userSteps[this.userStep].format;
    const step = this.userSteps[this.userStep].step;

    for (let m = moment(this.userStartDay); m.isBefore(moment(this.userEndDay)); m = m.add(step, 'days')) {
      const key = m.format(keyFormat);
      if (labelsHash[key] === undefined) {
        const l = labels.length;
        labels.push(key);
        labelsHash[key] = l;
        res.forEach((a) => {
          a[l] = 0;
        });
      }
    }

    let maxVal = 10;
    let companiesData = {'Alle': [0, 0]};

    for (let i = 0; i < this.usersData.length; i++) {
      this.usersData[i].forEach((log) => {
        if (this.userStartDay <= log._id.day && log._id.day <= this.userEndDay) {
          if (this.userCompany == 'Alle' || this.userCompany == log._id.company) {
            const key = moment(log._id.day).format(keyFormat);
            res[i][labelsHash[key]] += log.count;
          }
          companiesData['Alle'][i] += log.count;
          if (companiesData[log._id.company] === undefined) {
            companiesData[log._id.company] = [0, 0];
          }
          companiesData[log._id.company][i] += log.count;
        }
      });
      this.chartUser.datasets[i].data = res[i];
      maxVal = res[i].reduce((m, a) => m > a ? m : a, maxVal);
    }

    this.chartUser.options.scales.yAxes[0].ticks.max = Math.ceil(maxVal/10)*10;

    this.chartUser.labels = [];
    this.chartUser.labels.push(...labels);

    this.userCompaniesData = companiesData;
  }

  public changeUserDate() {
    const d = moment(this.userEndDay).diff(moment(this.userStartDay), 'days');
    let step = 'Jährlich';
    for (let key in this.userSteps) {
      if (this.userSteps[key].days > d) {
        step = key;
      }
    }
    this.userStep = step;
    this.calcUserCompanies();
    this.showUsers();
  }

  private refreshChart() {
    this.chartActivity.labels = [];
    this.chartActivity.labels.push(...this.tempChartLabels);
  }

  private refreshChartTheses() {
    this.chartThesis.labels = [];
    this.chartThesis.labels.push(...this.tempChartLabels);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/home/home.component.ts